import { Controller } from "@hotwired/stimulus"
import WaveSurfer from "wavesurfer.js"

// Lecteur audio avec waveform (WaveSurfer.js)
//
// Usage :
//   <div data-controller="audio-player"
//        data-audio-player-url-value="<%= rails_blob_url(@doc.file_attachment) %>"
//        data-audio-player-wave-color-value="#cbd5e1"
//        data-audio-player-progress-color-value="#2563eb">
//     <div data-audio-player-target="waveform"></div>
//     <button data-action="audio-player#togglePlay" data-audio-player-target="playButton">▶</button>
//     <span data-audio-player-target="time">0:00</span> / <span data-audio-player-target="duration">--:--</span>
//   </div>
export default class extends Controller {
  static targets = ["waveform", "playButton", "time", "duration"]
  static values = {
    url: String,
    waveColor: { type: String, default: "#cbd5e1" },
    progressColor: { type: String, default: "#2563eb" },
    height: { type: Number, default: 80 }
  }

  connect() {
    if (!this.urlValue || !this.hasWaveformTarget) return

    this.wavesurfer = WaveSurfer.create({
      container: this.waveformTarget,
      waveColor: this.waveColorValue,
      progressColor: this.progressColorValue,
      height: this.heightValue,
      barWidth: 2,
      barGap: 1,
      barRadius: 2,
      cursorWidth: 1,
      url: this.urlValue
    })

    this.wavesurfer.on("ready", () => this.updateDuration())
    this.wavesurfer.on("timeupdate", (t) => this.updateTime(t))
    this.wavesurfer.on("play", () => this.setPlayButton(true))
    this.wavesurfer.on("pause", () => this.setPlayButton(false))
    this.wavesurfer.on("finish", () => this.setPlayButton(false))
    this.wavesurfer.on("error", (e) => console.warn("AudioPlayer: WaveSurfer error", e))
  }

  disconnect() {
    if (this.wavesurfer) {
      this.wavesurfer.destroy()
      this.wavesurfer = null
    }
  }

  togglePlay(event) {
    event?.preventDefault()
    if (!this.wavesurfer) return
    this.wavesurfer.playPause()
  }

  updateDuration() {
    if (!this.hasDurationTarget || !this.wavesurfer) return
    this.durationTarget.textContent = this.formatTime(this.wavesurfer.getDuration())
  }

  updateTime(currentTime) {
    if (!this.hasTimeTarget) return
    this.timeTarget.textContent = this.formatTime(currentTime)
  }

  setPlayButton(playing) {
    if (!this.hasPlayButtonTarget) return
    this.playButtonTarget.dataset.playing = playing ? "true" : "false"
    this.playButtonTarget.setAttribute("aria-label", playing ? "Pause" : "Lecture")
  }

  formatTime(seconds) {
    if (!Number.isFinite(seconds)) return "--:--"
    const m = Math.floor(seconds / 60)
    const s = Math.floor(seconds % 60).toString().padStart(2, "0")
    return `${m}:${s}`
  }
}
